/**
 * ブレークポイント (px値)
 * (モバイル端末だと判定されるべき最大の Screen 幅／ViewPort 幅)
 */
export const breakPoint = 768


/**
 * アイテムレアリティの表示用文字列。
 * 公式サイトの item.json の "rarity" 値をキーに取る
 */
export const ItemRarities = {
  '': '',
  '1': 'R',
  '2': 'SR',
  '3': 'UR',
  '4': 'PMR',
  '5': 'HR',
  '6': 'OPR',
  '7': 'OPQR',
}


/**
 * アイテムカテゴリの表示用文字列。
 * 公式サイトの item.json の "category" 値をキーに取る
 */
export const ItemCategories = {
  '': '',
  '1': 'トップス',
  '2': 'ワンピース',
  '3': 'ボトムス',
  '4': 'シューズ',
  '5': 'ヘアアクセ',
}


/**
 * アイテムカラーの表示用文字列。
 * 公式サイトの item.json の "color" 値をキーに取る
 */
export const ItemColors = {
  '': '',
  '1': 'ちゃ',
  '2': 'あか',
  '3': 'ピンク',
  '4': 'オレンジ',
  '5': 'きいろ',
  '6': 'みどり',
  '7': 'みずいろ',
  '8': 'あお',
  '9': 'むらさき',
  '10': 'くろ',
  '11': 'しろ',
  '12': 'シルバー',
  '13': 'ゴールド',
}


/**
 * アイテムブランドの表示用文字列。
 * 公式サイトの item.json の "brand" 値をキーに取る
 */
export const ItemBrands = {
  '': '',
  '1': 'Lovely Melody',
  '2': 'Vivid Star',
  '3': 'Radiant Abyss',
  '4': 'Eternal Revue',
  '5': 'Electro Remix',
  '6': 'Cherry Sugar',
  '7': 'Shining Diva',
  '8': 'Prism Stone',
  '9': 'Princess Magic',
}


/**
 * アイテムジャンルの表示用文字列。
 * 公式サイトの item.json の "genre" 値をキーに取る
 */
export const ItemGenres = {
  '': '',
  '1': 'カジュアル',
  '2': 'スタイリッシュ',
  '3': 'ライブ',
}


/**
 * アイテムテイストの表示用文字列。
 * 公式サイトの item.json の "subCategory" 値をキーに取る
 * @note item.json において taste: "1" は一度も使用されていない。欠番と思われる。
 */
export const ItemTastes = {
  '': '',
  '1': '？',
  '2': 'フラワー',
  '3': 'スター',
  '4': 'ハート',
  '5': 'ガーリー',
  '6': 'キュート',
  '7': 'チェック',
  '8': 'リボン',
  '9': 'クール',
  '10': 'ゴシック',
  '11': 'ジュエル',
  '12': 'スポーティ',
  '13': 'ダンス',
  '14': 'ポップ',
  '15': 'ミステリアス',
  '16': 'ラブリー',
  '17': 'スイーツ',
  '18': 'ベーシック',
  '19': 'アニマル',
  '20': 'エレガント',
  '21': 'デジタル',
}


